<!--勤怠一覧-->
<template>
  <div class="k0001-content">
    <!--検索model-->
    <div class="search-module-k0001">
      <el-row style="padding-top:5px;padding-left:5px" :gutter="20">
        <el-col :span="7">
          <div>
            <el-date-picker v-model="kikanVal1" size="mini" type="date" style="width: 130px;font-size:12px;" :editable="false" :clearable="false" format="yyyy/MM/dd"></el-date-picker>
          </div>
        </el-col>
        <el-col :span="2" style="padding-left: 2px; padding-right: 10px;">
          <div>
            &nbsp;
          </div>
        </el-col>
        <el-col :span="7">
          <div>
            <el-date-picker v-model="kikanVal2" size="mini" type="date" style="width: 130px;font-size:12px;" :editable="false" :clearable="false" format="yyyy/MM/dd"></el-date-picker>
          </div>
        </el-col>
        <el-col :span="2">
          <div>&nbsp;</div>
        </el-col>
        <!--检索按钮-->
        <el-col :span="5">
          <div>
            <el-button type="primary" class="css-button_k0001 css-btn_k0001" v-loading.fullscreen.lock="fullscreenLoading" size="mini" @click="query_btn">{{$t('COMMON.LBL_SEARCH')}}</el-button>
          </div>
        </el-col>
      </el-row>
    </div>
    <el-table style=" border: 0px solid #AAAAAA" :header-cell-style="k0001HeaderStyle" :cell-style="k0001IsCellStyle" :header-row-class-name="k0001HeaderClass" :cell-class-name="k0001IsCellClass" :data="list" border @row-click="k0001RowOnClick" size="mini">
      <!--隐藏列-->
      <!--作業日-->
      <el-table-column fixed="left" prop="jobDate" align="center" v-if="false"></el-table-column>
      <!--ステータス-->
      <el-table-column fixed="left" prop="jobStateCd" align="center" v-if="false"></el-table-column>
      <el-table-column fixed="left" prop="jobStateName" align="center" v-if="false"></el-table-column>
      <!--企業名-->
      <el-table-column fixed="left" prop="companyName" align="center" v-if="false"></el-table-column>
      <!--現場名-->
      <el-table-column fixed="left" prop="fieldName" align="center" v-if="false"></el-table-column>
      <!--職種-->
      <el-table-column fixed="left" prop="typeName" align="center" v-if="false"></el-table-column>
      <!--入店予定-->
      <el-table-column fixed="left" prop="esStoreIn" align="center" v-if="false"></el-table-column>
      <!--入店実績-->
      <el-table-column fixed="left" prop="acStoreIn" align="center" v-if="false"></el-table-column>
      <!--退店予定-->
      <el-table-column fixed="left" prop="esStoreOut" align="center" v-if="false"></el-table-column>
      <!--退店実績-->
      <el-table-column fixed="left" prop="acStoreOut" align="center" v-if="false"></el-table-column>
      <!--更新時間-->
      <el-table-column fixed="left" prop="updateDate" align="center" v-if="false"></el-table-column>
      <!--勤怠承認-->
      <el-table-column fixed="left" prop="approvalFlag" align="center" v-if="false"></el-table-column>
      <!--作業区分-->
      <el-table-column fixed="left" prop="workType" align="center" v-if="false"></el-table-column>
      <!--add by hexy 20200921 start-->
      <!--連携フラグ-->
      <el-table-column fixed="left" prop="transmitFlag" align="center" v-if="false"></el-table-column>
      <!--add by hexy 20200921 end-->
      <!--显示列-->
      <!--作業日\ステータス\出勤区分-->
      <el-table-column prop="col1" :label="$t('MODULE.K0001_LBL_col1')" width="" text-align="center" align="left">
        <template slot-scope="scope">
          {{scope.row.jobDate}}
          <div>
            <el-image style="vertical-align: middle" v-if="(scope.row.workType==1||scope.row.workType==2) && scope.row.jobStateCd==0" :src="imgIconPlan" alt></el-image>
            <el-image style="vertical-align: middle" v-if="(scope.row.workType==1||scope.row.workType==2) && scope.row.jobStateCd==1" :src="imgIconUnderway" alt></el-image>
            <el-image style="vertical-align: middle" v-if="(scope.row.workType==1||scope.row.workType==2) && scope.row.jobStateCd==2" :src="imgIconComplete" alt></el-image>
            <!--作業区分は「3」-0:計画、1:出発済、2:入店済、3:退店済、4:作業完了-->
            <el-image style="vertical-align: middle" v-if="scope.row.workType==3 && scope.row.personalJobState==0" :src="imgIconPlan" alt></el-image>
            <el-image style="vertical-align: middle" v-if="scope.row.workType==3 && scope.row.personalJobState==1" :src="imgIconGoComplete" alt></el-image>
            <el-image style="vertical-align: middle" v-if="scope.row.workType==3 && scope.row.personalJobState==2" :src="imgIconUnderway" alt></el-image>
            <el-image style="vertical-align: middle" v-if="scope.row.workType==3 && scope.row.personalJobState==3" :src="imgIconCloseComplete" alt></el-image>
            <el-image style="vertical-align: middle" v-if="scope.row.workType==3 && scope.row.personalJobState==4" :src="imgIconComplete" alt></el-image>
            <template v-if="scope.row.workType==1||scope.row.workType==2"><span style="vertical-align: middle">{{scope.row.jobStateName}}</span></template>
            <template v-if="scope.row.workType==3"><span style="vertical-align: middle">{{scope.row.personalJobValue}}</span></template>
          </div>
          <div>{{scope.row.attenAbbr}}</div>
        </template>
      </el-table-column>
      <!--企業名\現場名\サービス名-->
      <el-table-column prop="col2" :label="$t('MODULE.K0001_LBL_col2')" width="" align="center">
        <template slot-scope="scope">
          {{scope.row.companyName}}<br>
          {{scope.row.fieldName}}<br>
          {{scope.row.serviceName}}
        </template>
      </el-table-column>
      <!--入店予定\入店実績-->
      <el-table-column prop="col3" :label="$t('MODULE.K0001_LBL_col3')" width="" align="center">
        <template slot-scope="scope">
          <div>{{scope.row.esStoreIn}}{{$t('MODULE.K0001_LBL_YO')}}</div>
          <div>{{scope.row.acStoreIn}}{{$t('MODULE.K0001_LBL_JI')}}</div>
          <!--入店コールボタン-->
          <el-button type="text" size="mini" class="css-button_k0001_l css-btn_k0001_l" @click="handleClick" v-show="needShow(scope.row,'storeInGoalButton')" @click.stop="departBtnFunction(scope.$index, scope.row)" v-loading.fullscreen.lock="fullscreenLoading" :disabled="NeedReadonly(scope.row,'storeInGoalButton')">{{$t('MODULE.K0001_BTN_DEPART')}}</el-button>
          <!--入店ボタン-->
          <el-button type="text" size="mini" class="css-button_k0001 css-btn_k0001" @click="handleClick" v-show="needShow(scope.row,'storeInButton')" @click.stop="inStoreBtnFunction(scope.$index, scope.row)" :disabled="NeedReadonly(scope.row,'storeInButton')">{{$t('MODULE.K0001_BTN_INSTORE')}}</el-button>
        </template>
      </el-table-column>
      <!--退店予定\退店実績-->
      <el-table-column prop="col4" :label="$t('MODULE.K0001_LBL_col4')" width="" align="center">
        <template slot-scope="scope">
          <div>{{scope.row.esStoreOut}}{{$t('MODULE.K0001_LBL_YO')}}</div>
          <div>{{scope.row.acStoreOut}}{{$t('MODULE.K0001_LBL_JI')}}</div>
          <div style='display:none'>{{scope.row.crewCd}}</div>
          <!--退店ゴールボタン-->
          <el-button type="text" size="mini" class="css-button_k0001_l css-btn_k0001_l" @click="handleClick" v-show="needShow(scope.row,'storeOutGoalButton')" @click.stop="quitBtnFunction(scope.$index, scope.row)" v-loading.fullscreen.lock="fullscreenLoading" :disabled="NeedReadonly(scope.row,'storeOutGoalButton')">{{$t('MODULE.K0001_BTN_QUIT')}}</el-button>
          <!--退店ボタン-->
          <el-button type="text" size="mini" class="css-button_k0001 css-btn_k0001" @click="handleClick" v-show="needShow(scope.row,'storeOutButton')" @click.stop="outStoreBtnFunction(scope.$index, scope.row)" :disabled="NeedReadonly(scope.row,'storeOutButton')">{{$t('MODULE.K0001_BTN_OUTSTORE')}}</el-button>
        </template>
      </el-table-column>
      <!--労働条件\通知書-->
      <el-table-column :label="$t('MODULE.K0001_LBL_col5')" width="" align="center">
        <template slot-scope="scope">
          <div v-if="scope.row.attendanceDiv=='0'||scope.row.attendanceDiv=='4'||scope.row.attendanceDiv=='5'" @click="click_notice(scope.row)" class="btn"><i class="el-icon-document-remove"></i></div>
          <!-- <el-button @click="click_notice(scope.row)" icon="el-icon-tickets" type="primary" size="mini"></el-button> -->
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import * as amsApi from '../api/k_0001'
import locale from 'element-ui/lib/locale/lang/ja'
import Vue from 'vue'
import ElementUI from 'element-ui'
let url = require('@/../config/sysConfig')
Vue.use(ElementUI, { locale })
export default {
  data() {
    return {
      userInfo: [],
      cl: '',
      listLoading: false,
      imgIconComplete: require('@/statics/images/Complete.png'),
      imgIconPlan: require('@/statics/images/plan.png'),
      imgIconUnderway: require('@/statics/images/underway.png'),
      imgIconCloseComplete: require('@/statics/images/close_complete.png'),
      imgIconGoComplete: require('@/statics/images/go_complete.png'),
      list: [],
      queryParams: {
        siteId: '' // サイトid
      },
      kikanVal1: '',
      kikanVal2: '',
      fullscreenLoading: false,
      // 実働時間
      realityTime: '00:00',
      // 内深夜実働時間
      lateRealityTime: '00:00'
    }
  },
  methods: {
    // 初期化
    init_query() {
      // 期間初期化
      var search_condition = JSON.parse(localStorage.getItem('search_condition'))
      if (search_condition == null) {
        var today = new Date()
        var torrom = new Date()
        this.kikanVal1 = today
        var torrom = torrom.setDate(torrom.getDate() + 1)
        torrom = new Date(torrom)
        this.kikanVal2 = torrom
        var search_condition = {}
        search_condition.fromDate = this.dateToString(this.kikanVal1, '0')
        search_condition.toDate = this.dateToString(this.kikanVal2, '0')
        localStorage.setItem('search_condition', JSON.stringify(search_condition))
      } else {
        var fromDate = search_condition.fromDate
        var toDate = search_condition.toDate
        if (search_condition.fromDate != null) {
          this.kikanVal1 = new Date(fromDate.substring(0, 4) + '/' + fromDate.substring(4, 6) + '/' + fromDate.substring(6, 8))
        } else {
          this.kikanVal1 = null
        }
        if (search_condition.toDate != null) {
          this.kikanVal2 = new Date(toDate.substring(0, 4) + '/' + toDate.substring(4, 6) + '/' + toDate.substring(6, 8))
        } else {
          this.kikanVal2 = null
        }
      }
      amsApi.home().then(res => {
        this.userInfo = res.items.userInfo
        localStorage.setItem('userInfo', JSON.stringify(this.userInfo))
      })
    },
    // 検索ボタン
    query_btn(e) {
      // 点击后失去焦点(用于按钮还原)
      let target = e.target
      target.blur()

      var search_condition = {}
      search_condition.fromDate = this.dateToString(this.kikanVal1, '0')
      search_condition.toDate = this.dateToString(this.kikanVal2, '0')
      localStorage.setItem('search_condition', JSON.stringify(search_condition))
      this.query()
    },
    // 検索
    query() {
      var dateFrom = ''
      var dateTo = ''
      if (this.dateToString(this.kikanVal1, '0') !== null) {
        dateFrom = this.dateToString(this.kikanVal1, '0')
      } else {
        dateFrom = null
      }
      if (this.dateToString(this.kikanVal2, '0') !== null) {
        dateTo = this.dateToString(this.kikanVal2, '0')
      } else {
        dateTo = null
      }
      if (dateFrom != null && dateTo != null && dateFrom > dateTo) {
        this.$message.error({ message: this.$t('COMMON.MSG_MESSAGE_ERROR_FROMDATE'), showClose: true })// 期間開始日＜＝期間終了日で設定してください。
      } else {
        var Params = {
          'dateFrom': dateFrom,
          'dateTo': dateTo
        }
        const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
        setTimeout(() => {
          loading.close()
        }, 2000)
        // 検索処理
        amsApi.k_0001(Params).then(res => {
          // 戻るリスト
          this.total = res.total
          this.list = res.items
          if (res.code === 300) {
            this.$message.warning({ message: this.$t('COMMON.NO_TARGET_DATA'), showClose: true })
            loading.close()
            return
          }
          loading.close()
        })
      }
    },
    // TABLEHeader样式
    k0001HeaderStyle({ row, column, rowIndex, columnIndex }) {
      return 'background-image:linear-gradient(#3cc6fa,#1197ca);color:#FFFFFF;box-shadow:  1px 1px 5px 0px 	rgba(0, 0, 0, 0.48);fontSize:10pt; '
    },
    // TABLE单元格样式
    k0001IsCellStyle({ row, colum, rowIndex, columnIndex }) {
      return 'text-align:center;fontSize:10pt'
    },
    // 时给确认画面link
    k0003linkClick() {
      window.open(url.testUrl)
    },
    // 单击行事件
    k0001RowOnClick(thisRowDate, column, cell, event) {
      // 计划的场合，点击无效
      if (thisRowDate.jobStateCd == 0) {
        return
      }
      if (column.property !== 'col1' && column.property !== 'col2') {
        return
      }
      thisRowDate.goalFlg = '3'
      localStorage.setItem('obj', JSON.stringify(thisRowDate))
      localStorage.setItem(url.routerUrl_K0002, JSON.stringify(true))
      this.$router.push({ path: url.routerUrl_K0002 })
    },
    // 入店按钮处理
    async inStoreBtnFunction(index, thisRowDate) {
      let res = await this.$confirm_hint(this.$t('COMMON.MSG_MESSAGE_INSTORE'),this.$t('COMMON.MSG_DELETE_CONFIRM'),this.$t('COMMON.MSG_DELETE_CANCEL'))
      if(res){//更新按钮
        var today = new Date()
        // システム時刻
        var strTodayHHMM = ''
        strTodayHHMM = this.dateToStringHHMM(today, 0)
        var strDate = this.dateToString(today, '1')
        // 作業日チェック
        if (strDate !== thisRowDate.jobDate) {
          this.$message.error({ message: this.$t('COMMON.MSG_ERROR_INSTORE_JOBDATE'), showClose: true }) // 作業日が異なります。入店できません。
          return
        }
        //作業開始処理
        if((thisRowDate.workType==1||thisRowDate.workType==2)&&thisRowDate.jobStateCd==0){
          var ret = await this.workStart(thisRowDate)
          if(!ret.successFlg){
            return
          }
        }
        var param = {}
        // 実働時間、内深夜実働時間計算
        this.realityTime = this.calculateWorkTime(strTodayHHMM, thisRowDate.acStoreOut, thisRowDate.allRestTime)
        this.lateRealityTime = this.calculateLatenightWorkTime(strTodayHHMM, thisRowDate.acStoreOut, thisRowDate.inLateBreak)
        param.div = '1'
        param.crewCd = thisRowDate.crewCd
        param.storePositionCd = thisRowDate.storePositionCd
        param.storeInTime = strTodayHHMM
        param.storeOutTime = thisRowDate.acStoreOut
        param.updateDate = thisRowDate.updateDate
        param.jobDate = thisRowDate.jobDate
        param.workTime = this.realityTime
        param.latenightWorkTime = this.lateRealityTime
        param.personalJobState = '2'
        amsApi.k_0001_update(param).then(res => {
          this.res_code_back(res)
        })
      }else{//取消按钮
        return
      }
    },
    // 退店按钮处理
    outStoreBtnFunction(index, thisRowDate) {
      var returnFlg = false//trueの場合、更新しない
      this.$confirm(this.$t('COMMON.MSG_MESSAGE_OUTSTORE'), { // 退店を更新します。よろしいですか。
        confirmButtonText: this.$t('COMMON.MSG_DELETE_CONFIRM'), // 更新
        cancelButtonText: this.$t('COMMON.MSG_DELETE_CANCEL'), // キャンセル
        center: true
      }).then(() => {
        // システム日(date)
        var today = new Date()
        // 昨日(date)
        var yesterday = new Date()
        yesterday = yesterday.setDate(today.getDate() - 1)
        yesterday = new Date(yesterday)
        // 昨日(str)
        var strYesterday = this.dateToString(yesterday, '1')
        // システム時刻
        var strTodayHHMM = ''
        // 棚卸日が昨日の場合、退店時+24処理
        if (strYesterday === thisRowDate.jobDate) {
          strTodayHHMM = this.dateToStringHHMM(today, 24)
        } else {
          strTodayHHMM = this.dateToStringHHMM(today, 0)
        }
        // システム時刻(num)))
        var min_sysDate = this.stringToMin(strTodayHHMM)
        // 未入店チェック
        if (thisRowDate.acStoreIn === null || thisRowDate.acStoreIn === '') {
          this.$message.error({ message: this.$t('COMMON.MSG_ERROR_OUTSTORE_INSTORE_NULL'), showClose: true })// 入店していないため、退店できません。
          returnFlg = true
        }
        if (returnFlg == false && (strYesterday > thisRowDate.jobDate)) { // 棚卸日が昨日以前の場合、更新しない
          this.$message.error({ message: this.$t('COMMON.MSG_ERROR_STORE_INOUT_JOBDATE'), showClose: true })// 作業日が異なります。退店できません。
          returnFlg = true
        }
        if (returnFlg == false) {
          // 入店時刻(num)
          var min_storeIn = this.stringToMin(thisRowDate.acStoreIn)
          // 入退店の関連チェック
          if (min_storeIn > min_sysDate) {
            this.$message.error({ message: this.$t('COMMON.MSG_STORE_INOUT_VALIDITY'), showClose: true }) // 入店＜退店で入力してください。
            returnFlg = true
          }
          // 入退店時刻の差チェック
          if (returnFlg == false && ((min_sysDate - min_storeIn) > 24 * 60)) {
            this.$message.error({ message: this.$t('COMMON.MSG_STORE_INOUT_SA_VALIDITY'), showClose: true }) // 入店時刻から退店時刻が24時間以内になるよう時刻を入力してください。
            returnFlg = true
          }
          // 退店時刻が46時を超えるかチェック
          if (returnFlg == false && (strYesterday === thisRowDate.jobDate && min_sysDate > 46 * 60)) { // 棚卸日が昨日且つ最大46：00 以上の場合
            this.$message.error({ message: this.$t('COMMON.MSG_ERROR_OUTSTORE_24'), showClose: true })// 退店時刻が最大46：00まで入力してください。
            returnFlg = true
          }
        }
        if (returnFlg == false) {
          var min_allRestTime = this.stringToMin(thisRowDate.allRestTime)
          // 休憩時間の合理性チェック 全休憩時間＞（退店-入店）
          if (min_allRestTime > (min_sysDate - min_storeIn)) {
            this.$message.error({ message: this.$t('COMMON.MSG_RESTTIME_VALIDITY'), showClose: true })// 休憩時間を正しく入力してください。
            returnFlg = true
          }
        }
        //以上チェックokの場合、更新処理
        if (returnFlg == false) {
          // 実働時間、内深夜実働時間計算
          this.realityTime = this.calculateWorkTime(thisRowDate.acStoreIn, strTodayHHMM, thisRowDate.allRestTime)
          this.lateRealityTime = this.calculateLatenightWorkTime(thisRowDate.acStoreIn, strTodayHHMM, thisRowDate.inLateBreak)
          var param = {}
          param.div = '2'
          param.crewCd = thisRowDate.crewCd
          param.storePositionCd = thisRowDate.storePositionCd
          param.storeInTime = thisRowDate.acStoreIn
          param.storeOutTime = strTodayHHMM
          param.updateDate = thisRowDate.updateDate
          param.jobDate = thisRowDate.jobDate
          param.workTime = this.realityTime
          param.latenightWorkTime = this.lateRealityTime
          param.personalJobState = '3'
          // 更新処理
          amsApi.k_0001_update(param).then(res => {
            this.res_code_back(res)
          })
        }
      }).catch(() => {
        // キャンセル
      })
    },
    k0001HeaderClass({ row, rowIndex }) {
      return 'k0001HeaderClass'
    },
    k0001IsCellClass({ row, rowIndex }) {
      return 'k0001IsCellClass'
    },
    // ログアウト処理
    log_out() {
      this.$message.closeAll()
      var vm = this
      vm.$router.push({ path: '/login' })
    },
    // 戻る処理
    back_click() {
      var vm = this
      vm.$router.push({ path: url.routerUrl_Menu })
    },
    // res_code処理
    res_code_back(res) {
      if (res.code === 202) {
        this.$message.success({ message: this.$t('COMMON.UPDATED'), showClose: true }) // 更新成功
        this.query()
      } else if (res.code === 308) {
        setTimeout(() => {
          this.$confirm(this.$t('COMMON.EXCLUSIVE'), { // 処理失敗しました、他の人が先に操作した可能性があります。最新情報を取得しますか？
            confirmButtonText: this.$t('COMMON.MSG_DELETE_CONFIRM'), // 更新
            cancelButtonText: this.$t('COMMON.MSG_DELETE_CANCEL'), // キャンセル
            center: true
          }).then(() => {
            this.query()
          }).catch(() => {
            // いいえ
          })
        }, 500)
      } else if (res.code === 408) {
        setTimeout(() => {
          this.$confirm(this.$t('COMMON.MSG_ERROR_STATE_OVER'), { // 作業状態はもう作業完了でした。他の人が先に更新した可能性があります。最新情報を取得しますか？
            confirmButtonText: this.$t('COMMON.MSG_DELETE_CONFIRM'), // 更新
            cancelButtonText: this.$t('COMMON.MSG_DELETE_CANCEL'), // キャンセル
            center: true
          }).then(() => {
            this.query()
          }).catch(() => {
            // いいえ
          })
        }, 500)
        // } else if (res.code === 427) {
        //   setTimeout(() => {
        //     this.$confirm(this.$t('COMMON.MSG_APPROVAL'), { // 勤怠承認済、戻り値メッセージを表示する
        //       confirmButtonText: this.$t('COMMON.MSG_DELETE_CONFIRM'), // はい
        //       cancelButtonText: this.$t('COMMON.MSG_DELETE_CANCEL'), // いいえ
        //       center: true
        //     }).then(() => {
        //       // はい
        //       this.query()
        //     }).catch(() => {
        //       // いいえ
        //     })
        //   }, 500)
      } else if (res.code === 617) {
        var reg1 = '{0}'
        var reg2 = '{1}'
        var msg = this.$t('COMMON.MSG_KINTAITIME_VALIDITY').replace(reg1, res.items.InOut).replace(reg2, res.items.dbInOut)
        this.$message.error({ message: msg, showClose: true }) // 更新失敗
      } else if (res.code === 428) {
        setTimeout(() => {
          this.$confirm(this.$t('COMMON.MSG_TRANSMIT'), { // 勤怠承認済、戻り値メッセージを表示する
            confirmButtonText: this.$t('COMMON.MSG_DELETE_CONFIRM'), // はい
            cancelButtonText: this.$t('COMMON.MSG_DELETE_CANCEL'), // いいえ
            center: true
          }).then(() => {
            // はい
            this.query()
          }).catch(() => {
            // いいえ
          })
        }, 500)
      } else {
        this.$message.error({ message: this.$t('COMMON.CURD_ERROR'), showClose: true }) // 更新失敗
      }
    },
    // date->string(0:yyyymmdd  1:yyyy/mm/dd ) 変化
    dateToString(dateTime, changeType) {
      var strTime = ''
      if (dateTime == null) { return null }
      var year = dateTime.getFullYear()
      var month = (dateTime.getMonth() + 1).toString()
      var day = (dateTime.getDate()).toString()
      if (month.length === 1) { month = '0' + month }
      if (day.length === 1) { day = '0' + day }
      if (changeType === '0') {
        strTime = year + month + day
      } else if (changeType === '1') {
        strTime = year + '/' + month + '/' + day
      } else {
        strTime = year + month + day
      }
      return strTime
    },
    // date->string(HH:MM) 変化
    dateToStringHHMM(dateTime, addHour) {
      var strTime = ''
      if (dateTime == null) { return '' }
      var hours = dateTime.getHours() + addHour
      var minutes = dateTime.getMinutes()
      if (hours < 10) { hours = '0' + hours }
      if (minutes < 10) { minutes = '0' + minutes }
      strTime = hours + ':' + minutes
      return strTime
    },
    // 時刻(分) str->num (00:00->num)
    stringToMin(time) {
      if (time === null || time === '') {
        return 0
      } else {
        return Number(time.substring(0, 2)) * 60 + Number(time.substring(3, 5))
      }
    },
    // 出発コール
    departBtnFunction(index, thisRowDate) {
      this.$confirm(this.$t('COMMON.MSG_JOBSTATE'), { // 作業開始します。よろしいでしょうか。
        confirmButtonText: this.$t('COMMON.MSG_DELETE_CONFIRM'), // はい
        cancelButtonText: this.$t('COMMON.MSG_DELETE_CANCEL'), // いいえ
        center: true
      }).then(() => {
        // 作業開始处理
        var today = new Date()
        var strTodayHHMM = this.dateToStringHHMM(today, 0)
        var strDate = this.dateToString(today, '1')
        // 作業日チェック
        if (strDate !== thisRowDate.jobDate) {
          this.$message.error({ message: this.$t('COMMON.MSG_ERROR_DEPART_JOBDATE'), showClose: true }) // 作業日が異なります。開始できません。
          return
        }
        var param = {}
        // 画面ID
        param.gamenId = 'SK_0001'
        // チェックフラグ
        param.checkFlg = '0'
        // 作業日
        param.jobDate = thisRowDate.jobDate
        // クルーコード
        param.crewCd = thisRowDate.crewCd
        // 受注NO
        // param.orderNo = thisRowDate.orderNo.replace(new RegExp('-', 'g'), '')
        // 作業状態
        param.jobState = '1'
        // 作業状態フラグ
        param.jobStateFlg = '0'

        this.openFullScreen()
        amsApi.jobStateApi(param).then(res => {
          // 关闭loading
          this.closeFullScreen(this.openFullScreen())
          var code = res.code
          switch (code) {
            case 412:
            case 201:
              this.$confirm(this.$t('COMMON.MSG_MESSAGE_DEPARTURE_CALL'), {// 出発記録します。よろしいでしょうか。
                confirmButtonText: this.$t('COMMON.MSG_DELETE_CONFIRM'),
                cancelButtonText: this.$t('COMMON.MSG_DELETE_CANCEL'),
                center: true
              }).then(() => {
                // はい 出発記録处理
                var param = {}
                param.div = '3'
                param.crewCd = thisRowDate.crewCd
                param.storePositionCd = thisRowDate.storePositionCd
                param.personalJobState = '1'
                param.jobDate = thisRowDate.jobDate
                // 出発コール
                param.departureCall = strTodayHHMM
                // 更新処理
                amsApi.k_0001_update(param).then(res => {
                  // 关闭loading
                  this.closeFullScreen(this.openFullScreen())
                  // 更新成功 跳转到详细
                  if (res.code === 202) {
                    this.changeFgl = false
                    thisRowDate.goalFlg = '1'
                    localStorage.setItem('obj', JSON.stringify(thisRowDate))
                    localStorage.setItem(url.routerUrl_K0002, JSON.stringify(true))
                    this.$router.push({ path: url.routerUrl_K0002 })
                  } else {
                    this.res_code_back(res)
                  }
                })
              }).catch(() => {
                // いいえ
                var param = {}
                param.div = '3'
                param.crewCd = thisRowDate.crewCd
                param.storePositionCd = thisRowDate.storePositionCd
                param.personalJobState = '1'
                param.jobDate = thisRowDate.jobDate
                // 出発コール
                param.departureCall = strTodayHHMM
                // 更新処理
                amsApi.k_0001_update(param).then(res => {
                  // 关闭loading
                  this.closeFullScreen(this.openFullScreen())
                  this.res_code_back(res)
                })
              })
              break
            case 311:
              this.$message.error({ message: this.$t('MODULE.MSG_CURD_ERROR'), showClose: true })
              break
          }

        }).catch((err) => {
          // 关闭loading
          this.closeFullScreen(this.openFullScreen())
        })
      }).catch(() => {
        // いいえ
      })
    },
    // 退店コール
    quitBtnFunction(index, thisRowDate) {
      if (thisRowDate.jobStateCd === '0') {
        return
      }
      thisRowDate.goalFlg = '2'
      localStorage.setItem('obj', JSON.stringify(thisRowDate))
      localStorage.setItem(url.routerUrl_K0002, JSON.stringify(true))
      this.$router.push({ path: url.routerUrl_K0002 })
    },
    // quitBtnFunction_B (thisRowDate) {
    //   var param = {}
    //   // 画面ID
    //   param.gamenId = 'SK_0001'
    //   // チェックフラグ
    //   param.checkFlg = '0'
    //   // 作業日
    //   param.jobDate = ''
    //   // クルーコード
    //   param.crewCd = thisRowDate.crewCd
    //   // 受注NO
    //   param.orderNo = thisRowDate.orderNo.replace(new RegExp('-', 'g'), '')
    //   // 作業状態
    //   param.jobState = '2'
    //   // 作業状態フラグ
    //   param.jobStateFlg = '1'
    //   amsApi.jobStateApi(param).then(res => {
    //     var code = res.code
    //     switch (code) {
    //       case 402:
    //         this.$message.error({ message: this.$t('COMMON.MSG_STORETIME_NOT_INPUT'), showClose: true })
    //         break
    //       case 403:
    //         this.$message.error({ message: this.$t('COMMON.MSG_SIGN_NOT_INPUT'), showClose: true })
    //         break
    //       case 405:
    //         this.$message.error({ message: this.$t('COMMON.MSG_SOTRESIGN_NOT_INPUT'), showClose: true })
    //         break
    //       case 418:
    //         this.$message.error({ message: this.$t('COMMON.MSG_TIME_VALIDITY'), showClose: true })
    //         break
    //       case 408:
    //         this.$confirm(this.$t('COMMON.MSG_ERROR_STATE_OVER'), {
    //           confirmButtonText: this.$t('COMMON.MSG_DELETE_CONFIRM'),
    //           cancelButtonText: this.$t('COMMON.MSG_DELETE_CANCEL'),
    //           center: true
    //         }).then(() => {
    //           // はい
    //           this.query()
    //         }).catch(() => {
    //           // いいえ
    //         })
    //         break
    //       case 412:
    //         this.$confirm(this.$t('COMMON.MSG_STATE_ING'), {
    //           confirmButtonText: this.$t('COMMON.MSG_DELETE_CONFIRM'),
    //           cancelButtonText: this.$t('COMMON.MSG_DELETE_CANCEL'),
    //           center: true
    //         }).then(() => {
    //           // はい
    //           this.query()
    //         }).catch(() => {
    //           // いいえ
    //         })
    //         break
    //       case 428:
    //         this.$confirm(this.$t('COMMON.MSG_TRANSMIT'), {
    //           confirmButtonText: this.$t('COMMON.MSG_DELETE_CONFIRM'),
    //           cancelButtonText: this.$t('COMMON.MSG_DELETE_CANCEL'),
    //           center: true
    //         }).then(() => {
    //           // はい
    //           this.query()
    //         }).catch(() => {
    //           // いいえ
    //         })
    //         break
    //       case 202:
    //         this.$message.success({ message: this.$t('COMMON.UPDATED'), showClose: true })
    //         this.query()
    //         break
    //       case 201:
    //         this.$message.success({ message: this.$t('COMMON.MSG_INSERTED'), showClose: true })
    //         this.query()
    //         break
    //       case 311:
    //         this.$message.error({ message: this.$t('MODULE.MSG_CURD_ERROR'), showClose: true })
    //         break
    //     }
    //   }).catch((err) => {
    //     // 关闭loading
    //     this.closeFullScreen(this.openFullScreen())
    //   })
    // },
    disabledFunction(thisRowDate) {
      if (thisRowDate.jobStateCd == '1' && thisRowDate.acStoreOut != '') {
        return false // 活性
      }
      if ((thisRowDate.jobStateCd != '1') || (thisRowDate.jobStateCd == '1' && thisRowDate.acStoreOut == '')) {
        return true // 非活性
      }
    },
    needShow(thisRowDate, type) {
      var showReturn = false
      if (thisRowDate.timeFlag === '0') {//該当作業の時刻フラグが0
        return false
      }
      switch (type) {
        case 'storeInButton':
          if ((thisRowDate.workType == '1' || thisRowDate.workType == '2') && thisRowDate.jobStateCd != '2' && this.isEmpty(thisRowDate.acStoreOut)) {
            showReturn = true
          }
          if (thisRowDate.workType == '3' && thisRowDate.personalJobState == '1') {
            showReturn = true
          }
          break
        case 'storeOutButton':
          if ((thisRowDate.workType == '1' || thisRowDate.workType == '2') && thisRowDate.jobStateCd == '1' && !this.isEmpty(thisRowDate.acStoreIn)) {
            showReturn = true
          }
          if (thisRowDate.workType == '3' && thisRowDate.personalJobState == '2') {
            showReturn = true
          }
          break
        case 'storeInGoalButton':
          if (thisRowDate.workType == '3' && thisRowDate.personalJobState == '0') {
            showReturn = true
          }
          break
        case 'storeOutGoalButton':
          if (thisRowDate.workType == '3' && thisRowDate.personalJobState == '3') {
            showReturn = true
          }
          break
      }
      return showReturn
    },
    NeedReadonly(thisRowDate, type) {
      var readonlyReturn = false
      if (thisRowDate.transmitFlag == '1' || thisRowDate.jobStateCd == '2') {
        readonlyReturn = true
      }
      return readonlyReturn
    },
    isEmpty(value){
      if(typeof value=="undefined"||value==null||value==''){
        return true
      }else{
        return false
      }
    },
    // 点击后失去焦点(用于按钮还原)
    handleClick(e) {
      let target = e.target
      target.blur()
    },
    // Loading加载
    openFullScreen() {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      return loading
    },
    closeFullScreen(loading) {
      loading.close()
    },
    // 计算実動時間  退店-入店-全休憩時間。
    calculateWorkTime(storeIn, storeOut, allRestTime) {
      var cal_result = 0
      if (storeIn === null || storeIn === '' || storeOut === null || storeOut === '') {
        cal_result = 0
      } else {
        var cal_storeIn = (storeIn === null || storeIn === '') ? '0' : Number(storeIn.substring(0, 2)) * 60 + Number(storeIn.substring(3, 5))
        var cal_storeOut = (storeOut === null || storeOut === '') ? '0' : Number(storeOut.substring(0, 2)) * 60 + Number(storeOut.substring(3, 5))
        var cal_allRestTime = (allRestTime === null || allRestTime === '') ? '0' : Number(allRestTime.substring(0, 2)) * 60 + Number(allRestTime.substring(3, 5))
        cal_result = (cal_storeOut - cal_storeIn - cal_allRestTime) < 0 ? 0 : (cal_storeOut - cal_storeIn - cal_allRestTime)
      }
      var ret = this.minuteTOtime(cal_result)
      return ret
    },
    // 计算内深夜実動時間  深夜时间-内深夜休憩時間。
    calculateLatenightWorkTime(storeIn, storeOut, inLateBreak) {
      var cal_result = 0
      if (storeIn === null || storeIn === '' || storeOut === null || storeOut === '') {
        cal_result = 0
      } else {
        var cal_storeIn = (storeIn === null || storeIn === '') ? '0' : Number(storeIn.substring(0, 2)) * 60 + Number(storeIn.substring(3, 5))
        var cal_storeOut = (storeOut === null || storeOut === '') ? '0' : Number(storeOut.substring(0, 2)) * 60 + Number(storeOut.substring(3, 5))
        var cal_inLateBreak = (inLateBreak === null || inLateBreak === '') ? '0' : Number(inLateBreak.substring(0, 2)) * 60 + Number(inLateBreak.substring(3, 5))
        var inlateBlock = this.getInLateBlock(cal_storeIn, cal_storeOut)// 深夜时间取得
        cal_result = (inlateBlock - cal_inLateBreak) < 0 ? 0 : (inlateBlock - cal_inLateBreak)
      }
      var ret = this.minuteTOtime(cal_result)
      return ret
    },
    // 深夜时间带计算
    // 深夜时段：时间带1：00:00~05:00  时间带2：22:00~29:00
    getInLateBlock(value_in, value_out) {
      var ret_totalTime = 0
      var cal_value_out = 0
      var cal_value_in = 0
      var S_IN1 = 0
      var S_OUT1 = 5 * 60
      var S_IN2 = 22 * 60
      var S_OUT2 = 29 * 60
      // 时间带1计算
      if ((S_IN1 <= value_in && value_in <= S_OUT1) || (S_IN1 <= value_out && value_out <= S_OUT1)) {
        cal_value_in = value_in < S_IN1 ? S_IN1 : value_in
        cal_value_out = value_out > S_OUT1 ? S_OUT1 : value_out
        ret_totalTime = cal_value_out - cal_value_in + ret_totalTime
      } else if ((S_IN1 >= value_in && value_out >= S_OUT1)) {
        ret_totalTime = S_OUT1 - S_IN1 + ret_totalTime
      }
      cal_value_out = 0
      cal_value_in = 0
      // 时间带2计算
      if ((S_IN2 <= value_in && value_in <= S_OUT2) || (S_IN2 <= value_out && value_out <= S_OUT2)) {
        cal_value_in = value_in < S_IN2 ? S_IN2 : value_in
        cal_value_out = value_out > S_OUT2 ? S_OUT2 : value_out
        ret_totalTime = cal_value_out - cal_value_in + ret_totalTime
      } else if ((S_IN2 >= value_in && value_out >= S_OUT2)) {
        ret_totalTime = S_OUT2 - S_IN2 + ret_totalTime
      }
      return ret_totalTime
    },
    // 分钟 转 【时：分】
    minuteTOtime(val) {
      var ret = ''
      if (val === '' || val === '0') {
        ret = '00:00'
      } else {
        ret = ((Math.floor(val / 60)).toString().length < 2 ? '0' + (Math.floor(val / 60)).toString() : (Math.floor(val / 60)).toString()) + ':' + ((val % 60).toString().length < 2 ? '0' + (val % 60).toString() : (val % 60).toString())
      }
      return ret
    },
    //労働条件通知書
    click_notice(row) {
      let info = JSON.parse(localStorage.getItem("userInfo"))
      setTimeout(() => {
        this.$router.push({ path: url.routerUrl_C0003, query: { "jobDate": row.jobDate, "fieldCd": row.fieldCd, "userCd": info.userCd, "storePositionCd": row.storePositionCd } })
      }, 300)
    },
    //入店ボタン用、作業開始処理
    async workStart(thisRowDate){
      var ret={
        successFlg:false,
      }
      var param = {}
      // 画面ID
      param.gamenId = 'SK_0001'
      // チェックフラグ
      param.checkFlg = '0'
      // 作業日
      param.jobDate = thisRowDate.jobDate
      // クルーコード
      param.crewCd = thisRowDate.crewCd
      // 作業状態
      param.jobState = '1'
      // 作業状態フラグ
      param.jobStateFlg = '0'
      return new Promise(resolve => {
        amsApi.jobStateApi(param).then(res => {
          if(res.code == '201'||'412') {
            ret.successFlg = true
            resolve(ret)
          }else if(res.code == '311'){
            ret.successFlg =false
            this.$message.error({ message: this.$t('MODULE.MSG_CURD_ERROR'), showClose: true })
            resolve(ret)
          }else{ 
            ret.successFlg =false
            this.$message.error({ message: this.$t('COMMON.CURD_ERROR'), showClose: true });
            resolve(ret)
          }
        })
      }).catch((err) => {
          resolve(ret)
      });  
    },
  },
  created() {
    // 初期化
    this.init_query()
    // 期間より検索
    this.query()
  }
}

</script>
<style scope>
/*カラー*/
.css-white {
  color: #ffffff;
}
.k0001IsCellClass .cell {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.k0001HeaderClass .cell {
  white-space: pre-line;
}
.search-module-k0001 {
  padding-bottom: 10px;
  margin-bottom: 5px; /*检索模块与表格间距*/
  background-image: linear-gradient(#f8f6f6, #dfdfdf);
  border: solid 0px #999999;
}
/*ボタン*/
.css-button_k0001 {
  background-image: linear-gradient(#3cc6fa, #1197ca);
  color: #ffffff;
  width: 100%;
  font-size: 10pt;
}
/*按钮经过样式*/
.css-btn_k0001:hover {
  background-image: linear-gradient(0deg, #0f91c2, #41bae6);
  color: #ffffff;
}
/*按钮激活和焦点样式*/
.css-btn_k0001:active,
.css-btn_k0001:focus {
  background-image: linear-gradient(0deg, #29a8d8, #29a8d8);
  color: #ffffff;
}
/*按钮非活性和焦点样式*/
.css-btn_k0001.is-disabled,
.css-btn_k0001.is-disabled:focus,
.css-btn_k0001.is-disabled:hover {
  background-image: linear-gradient(#5bd3ff, #5bd3ff);
  color: #ffffff;
}

/*ボタン*/
.css-button_k0001_l {
  background-image: linear-gradient(#fad52e, #daa516);
  color: #ffffff;
  width: 100%;
}
/*按钮经过样式*/
.css-btn_k0001_l:hover {
  background-image: linear-gradient(0deg, #fad52e, #d1a838);
  color: #ffffff;
}
/*按钮激活和焦点样式*/
.css-btn_k0001_l:active,
.css-btn_k0001_l:focus {
  background-image: linear-gradient(#fad52e, #daa516);
  color: #ffffff;
}
/*按钮非活性和焦点样式*/
.css-btn_k0001_l.is-disabled,
.css-btn_k0001_l.is-disabled:focus,
.css-btn_k0001_l.is-disabled:hover {
  background-image: linear-gradient(#ffd373, #ffd373);
  color: #ffffff;
}

/*导航*/
.home-content-menu_k0001 {
  padding-left: 0;
  height: 40px;
  background-color: #23b2e8;
}
/*面包屑*/
.el-crumb_k0001 {
  background-image: linear-gradient(#5c5d5d, #717171);
  padding-left: 5px;
  padding-top: 4px;
  height: 20px;
}
/*ステータス*/
.image_bottom_k001 {
  margin-bottom: -8px;
}
.k0001-content .el-table th > .cell,
.k0001-content .el-table td.k0001IsCellClass:nth-child(1) .cell {
  padding: 0 !important;
}
.k0001-content .el-table td.k0001IsCellClass:nth-child(1) .cell {
  overflow: visible;
}

.k0001-content .el-table td.k0001IsCellClass .cell {
  padding: 0 5px !important;
}
.k0001-content .el-table td.k0001IsCellClass {
  width: 20px;
}
.k0001-content .el-table__header {
  width: 100% !important;
}
.k0001-content .el-table__body {
  width: 100% !important;
}

.k0001-content colgroup col:not(.k0001-content colgroup col:nth-child(1)) {
  /* display: none; */
  width: auto;
}
.k0001-content colgroup col:nth-child(6) {
  display: none;
}

.k0001-content colgroup col {
  /* display: none; */
  width: 20%;
}
@media (max-width: 400px) {
  .k0001-content colgroup col {
    /* display: none; */
    width: 24%;
  }
}
.k0001-content .btn i {
  font-size: 20px;
  color: #409eff;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/module/page/k_0001.vue